module.exports = __webpack_public_path__ + "img/work.bafa66e4.png";